var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer5 = function SvgNumTimer5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M2.067 25.112h11.256v-5.664H5.307q-1.68 0-2.472-.768-.768-.768-.768-2.472V7.52h15.552v3.888H6.675v4.248h8.016q1.68 0 2.448.768.792.768.792 2.472v6.864q0 1.68-.768 2.472-.768.768-2.472.768H2.067z"
  })));
};
export default SvgNumTimer5;